import React, {Component} from 'react'

import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

import Logo from '../img/logo.png'

const style = {
  details:{
    paddingLeft: '16px',
    paddingRight: '16px',
  }
}

export default class PrivateJob extends Component{
  render(){
    return(
      <Fade in={true}>
        <Card className="card" >
          <CardHeader
            avatar={
              <Avatar
                aria-label={document.title}
                src={Logo}
              />
            }
            title={'Private Job.'}
            subheader={'This Job is set to Private. Only invited candidates may apply.'}
          />
          <CardContent>
            <Typography style={style.details} type="body1">
              Please check back again soon for updates or make sure that you are logged in with the correct account.
            </Typography>
          </CardContent>
        </Card>
      </Fade>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PrivateJob.js